import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeaderGraph} from '../../../apis/leader/getLeaderGraph'

const useQueryLeaderGraph = (id?: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getLeaderGraph(id),
        queryFn: async () => {
            const {data} = await getLeaderGraph(id)
            return data
        },
        refetchOnWindowFocus: false,
        enabled: !!id,
    })

    return {data, refetch, isLoading}
}

export default useQueryLeaderGraph
